import { render, staticRenderFns } from "./ExtractFormSelect.vue?vue&type=template&id=610cfb84&scoped=true&"
import script from "./ExtractFormSelect.vue?vue&type=script&lang=ts&"
export * from "./ExtractFormSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cfb84",
  null
  
)

export default component.exports